export class QRDropdown {
  hierarchy!: string;
  size!: number;
  placeholder?: string;
  options!: string[];
  isMultiple?: boolean = false;
  buttonEnd?: boolean = false;
  optionImages?: Record<string, string>; // Imagen a mostrar a la izquierda de cada opción (key: opción)

  // Jerarquía
  public static readonly HIERARCHY_1 = 'hierarchy-1';

  // Tamaños
  public static readonly SIZE_MEDIUM = 40;
  public static readonly SIZE_SMALL = 32;
}
